import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Box, Typography } from '@mui/material';
import FileIcon from '../FileIcon';
const DownloadPopper = ({ file }) => {
    return (_jsxs(Box, Object.assign({ display: "inline-block" }, { children: [_jsxs(Box, Object.assign({ mb: 3, sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(FileIcon, { filename: file.name }), _jsx(Typography, Object.assign({ variant: 'body1', sx: { marginLeft: "8px" } }, { children: file.name }))] })), _jsx(Typography, Object.assign({ textAlign: 'right' }, { children: _jsx("a", Object.assign({ target: "_blank", rel: "noreferrer", style: { color: "#4E3BC9", fontWeight: 600 }, href: file.url, download: true }, { children: "Download Now" })) }))] })));
};
DownloadPopper.propTypes = {
    file: PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string
    })
};
export default DownloadPopper;
